export default {"src":"/_next/static/media/politic.1e5144bb.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};